import {createContext} from 'react';
import {noop} from '@priority-software/priority-style-react';

const defaultValue = {
    escClosable: true,
    handleEscClosable: noop,
    session: '',
    closeCurrentAutomation: noop,
    toggleHasTemporaryEmailTemplate: noop,
    hasTemporaryEmailTemplate: false,
    aiLoading: false,
    setAiLoading: noop
};

export type RuleDialogContextModel = {
    escClosable: boolean;
    session: string;
    handleEscClosable: (flag: boolean) => void;
    closeCurrentAutomation: () => void;
    hasTemporaryEmailTemplate: boolean;
    toggleHasTemporaryEmailTemplate: (flag: boolean) => void;
    aiLoading: boolean;
    setAiLoading: (loading: boolean) => void;
};
export const RuleDialogContext = createContext<RuleDialogContextModel>(defaultValue);
